import {
  IsNumber,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateTeachingStaffDto {
  @ApiProperty({ type: 'string', description: "ID de l'enseignement" })
  @IsNotEmpty()
  @IsString()
  teachingId!: string

  @ApiProperty({ type: 'string', description: "ID de l'utilisateur enseignant" })
  @IsNotEmpty()
  @IsString()
  teacherUserId!: string

  @ApiProperty({ type: 'string', description: 'ID du rôle' })
  @IsNotEmpty()
  @IsUUID('4')
  roleId!: string

  @ApiPropertyOptional({ type: Number, description: 'Part de charge de travail' })
  @IsOptional()
  @IsNumber()
  workloadShare?: number
}
